// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-page.budget-request .card-header button.btn {
  padding-left: 60px;
}
.details-page .box {
  width: 16px;
  height: 15px;
  display: inline-block;
  top: 2px;
  border-radius: 6px;
  margin-right: 5px;
  position: relative;
}
.details-page .planning h6 {
  font-weight: bold;
}
.details-page .form-row.planning {
  overflow-x: auto;
  overflow-y: hidden;
}
.details-page .planning-mtp-diff-hint {
  color: #dc3545;
  font-size: 1.44rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
}
.details-page .planning-table input.planning-mtp-diff {
  color: #dc3545 !important;
  font-weight: 600;
}
.details-page h5.warning-label {
  font-size: 16px;
}
.details-page .btn {
  cursor: pointer;
}
.details-page .nameReview {
  word-break: break-all;
}
.details-page h5 span {
  color: #212529;
}
.details-page .menu-save {
  align-items: flex-start;
  padding-top: 8px;
}
.details-page .menu-save a {
  font-size: 16px;
}
.details-page .menu-save a.pointerLink {
  margin-left: 0px;
  color: initial !important;
}
.details-page a.menu-details {
  font-weight: bold;
}
.details-page .menu-details.history {
  color: #adadad;
  cursor: pointer;
}
.details-page .menu-details.tab-active {
  padding-bottom: 5px;
  border-bottom: 2px solid #0078dc;
  cursor: pointer;
  color: rgb(0, 120, 220);
}
.details-page .menu-details.tab-active:hover,
.details-page .menu-details.history:hover {
  color: rgb(0, 120, 220);
}
.details-page .dropdown-toggle-left::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  margin-right: 10px;
}
.details-page .btn-primary {
  border-radius: 2.08rem;
  background-color: #0062cc;
  padding: 8px 40px;
  box-shadow: none !important;
  border: none;
}
.details-page .btn-primary:hover {
  background-color: #0062cc;
}
.details-page .inactive-btn {
  background-color: rgba(0, 98, 204, 0.4705882353);
  cursor: default;
}
.details-page .inactive-btn:active, .details-page .inactive-btn:hover, .details-page .inactive-btn:focus {
  background-color: rgba(0, 98, 204, 0.4705882353) !important;
}
.details-page textarea {
  width: 100%;
}
.details-page .btn-link {
  color: #4d4d4d;
  text-decoration: none !important;
}
.details-page .btn-link:active {
  text-decoration: none;
}
.details-page .btn-link:hover {
  text-decoration: none;
}
.details-page .multiselect {
  padding-bottom: 15px;
}
.details-page .multiselect--disabled {
  background: none;
}
.details-page .section-first .multiselect {
  padding-bottom: 15px;
  border-bottom: 1px solid #adadad;
  width: 93%;
}
.details-page .section-first .multiselect--disabled .multiselect__select {
  display: none;
}
.details-page .accordion-funding-status .multiselect--disabled .multiselect__select {
  display: none;
}
.details-page .accordion-funding-status, .details-page .accordion-tags {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.details-page .menu-save .dropright .dropdown-menu {
  top: 30px;
  left: 15%;
}
.details-page .menu-save .dropright:hover > .dropdown-menu {
  display: block;
}
.details-page .menu-save .dropdown-item span {
  padding-left: 10px;
}
@media (max-width: 575px) {
.details-page .menu-save .dropright .dropdown-menu {
    left: 0;
}
}
.details-page #accordionFin .multiselect {
  border-bottom: none;
  padding-bottom: 5px;
}
.details-page .accordion-review .multiselect--disabled .multiselect__select {
  height: 40px;
}
.details-page .accordion-review .checkbox-flag {
  padding-left: 0;
}
.details-page .accordion-review .checkbox-flag input, .details-page .accordion-review .checkbox-flag span {
  vertical-align: middle;
}
a.button-edit {
  cursor: pointer;
  color: rgb(0, 120, 220) !important;
}
.icon-flag {
  position: relative;
  margin-right: 7px;
  top: 0px;
}
.multiselect__option--highlight {
  background-color: #0078dc !important;
  outline: none;
  color: #fff;
}
.multiselect__tag {
  background-color: #0078dc !important;
}
.multiselect__tag-icon:hover {
  background: #0078dc !important;
}
.multiselect__tags {
  border: 1px solid rgb(169, 169, 169) !important;
}
.icon-right {
  color: #adadad;
  font-size: 14px;
  padding: 0 10px;
}
.mtp-color {
  color: #0078dc;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
